import { isSSR } from 'utils';

export const isDemo = (): boolean | undefined => {
  if (!isSSR) {
    return window.location.hostname.includes('isdemo.se');
  }
};
